"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ActionType;

(function (ActionType) {
  ActionType["Play"] = "play";
  ActionType["Pause"] = "pause";
  ActionType["Seek"] = "seek";
  ActionType["LoadScene"] = "loadScene";
  ActionType["RequestFullscreen"] = "requestFullscreen";
  ActionType["ExitFullscreen"] = "exitFullscreen";
  ActionType["FunctionCall"] = "functionCall";
  ActionType["Tag"] = "tag";
  ActionType["ThumbsUp"] = "thumbsUp";
  ActionType["ThumbsDown"] = "thumbsDown";
})(ActionType = exports.ActionType || (exports.ActionType = {}));